import vClickOutside from "v-click-outside";

export default {
	props: {
		content: Array,
		// align the modal to the: left | right | center
		position: {
			type: String,
			default: "left",
			validator(value) {
				return ["left", "right", "center"].includes(value);
			},
		},
	},

	data() {
		return { show: false };
	},

	methods: {
		closeTooltip,
		toggleTooltip,
	},

	directives: { clickOutside: vClickOutside.directive },
};

function closeTooltip() {
	this.show = false;
}

function toggleTooltip() {
	this.show = !this.show;
}
